import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import { ReactSVG } from "react-svg";
import { useMemo, useState } from "react";
import QuesImg from '@/assets/svg/ques3.svg'
import GachaImg from '@/assets/svg/gacha.svg'
import { ethers } from "ethers";
import NftImg1 from '@/assets/imgs/nfts/1.jpg'
import NftImg2 from '@/assets/imgs/nfts/2.jpg'
import NftImg3 from '@/assets/imgs/nfts/3.jpg'
import NftImg4 from '@/assets/imgs/nfts/4.jpg'
import NftImg5 from '@/assets/imgs/nfts/5.jpg'
import NftImg6 from '@/assets/imgs/nfts/6.jpg'
import BtnL from '@/assets/svg/btn-l.svg'
import BtnR from '@/assets/svg/btn-r.svg'
import { useContractWrite, useAccount, useContractRead } from 'wagmi'
import { NFTCA, nftAbi, GochaCA, gachaAbi, topicEventCA } from '@/utils/abi'
import { arbitrumGoerli } from 'wagmi/chains'
import { useToastContext } from "@/contexts/ToastContext";


export default function Mint({ handleClose, gacha, mintCb }) {
  const [isMinting, setIsMingting] = useState(false)  
  const [isApproving, setIsApproving] = useState(false)
  const [count, setCount] = useState(1)
  const { address } = useAccount();
  const { showToast } = useToastContext();

  const { data: allowance } = useContractRead({
    address: GochaCA,
    abi: gachaAbi,
    functionName: 'allowance',
    args: [address, NFTCA],
    watch:true
  })


  const allowanceNum = useMemo(()=> allowance && ethers.utils.formatUnits(allowance, 18) || 0, [allowance])  

  const isApproved = useMemo(()=> allowanceNum >= count, [allowanceNum, count])  

  const btnText = useMemo(()=> isApproving ? 'Approving' : (isMinting ? 'Minting...' : (isApproved ? 'Mint Now' : 'Approve Your Gacha' )), [isApproved, isApproving, isMinting])  

  const { writeAsync:writeAsyncApprove } = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: GochaCA,
    abi: gachaAbi,
    functionName: 'approve',
    args: [NFTCA, ethers.constants.MaxUint256],
    chainId: arbitrumGoerli.id,
  })

  const { writeAsync:writeAsyncSingleDraw } = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: NFTCA,
    abi: nftAbi,
    functionName: 'draw',
    chainId: arbitrumGoerli.id,
    args:[],
    onError(error) {
      console.log('Error', error)
    },
  })
  
  const { writeAsync:writeAsyncBatchDraw } = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: NFTCA,
    abi: nftAbi,
    functionName: 'batchDraw',
    chainId: arbitrumGoerli.id,
    args: [`${count}`],
    onError(error) {
      console.log('Error', error)
    },
  })
  
  
  
  const handleIncrement = () => {
    if (count < 3) {
      setCount(count + 1);
    }
  };

  const handleDecrement = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const handleMax = () => {
    if(gacha < 3){
      setCount(gacha);  
    }else{
      setCount(3);
    }
  };

  const handleClick = async() => {
    if(count > gacha || isApproving || isMinting) return
    
    try {
      if(isApproved){
        let result = null
        setIsMingting(true)
        
        if(count > 1){
          const batchDraw = await writeAsyncBatchDraw()
          result = await batchDraw.wait()
        }else{
          const draw = await writeAsyncSingleDraw()
          result = await draw.wait()
        }
        
        setIsMingting(false)
        let nftArr = (result?.logs || []).filter(item => item?.topics[0] === topicEventCA && item?.topics?.length === 4)
        nftArr = nftArr.map(i => parseInt(i.topics[3]))
        mintCb(nftArr)

      }else{

        setIsApproving(true)
        const approveR = await writeAsyncApprove()
        const approveWait = await approveR.wait()
        if(approveWait?.status === 1){          
          setIsApproving(false)
        }else{
  
        }      
      } 
    } catch (error) {   
      setIsMingting(false)
      setIsApproving(false)        
      showToast({
        dir:'top',
        type:'error',
        text:'Fail，Please try again'
      })
    }
  };

  return (
    <Modal>      
      <div className='close' onClick={handleClose}><ReactSVG src={CloseImg}/></div>
      <div className="content">        
        <div className="main-title">Minting now!</div>
        <div className="line"></div>
        <div className="inner">
          <div className="inner-left">
            <div className="title">Jungle Squad</div>
            <div className="common-line sub-title">
              <span className="common-left sub-title-l">Your balance</span>
              <span className="common-right sub-title-r">{gacha} Gacha</span>
            </div>
            <div className="desc">
              <ReactSVG className="ques-img" src={QuesImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
              <div className="desc-content">Please fill in the amount of boxes you would like to exchange with gacha.</div>
            </div>
            <div className="btn-comp">
              <div className="button-control">
                <ReactSVG onClick={handleDecrement} className="bc-l" src={BtnL} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                <div>{count}</div>
                <ReactSVG onClick={handleIncrement} className="bc-r" src={BtnR} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
              </div>
              <div className="max-txt" onClick={handleMax}>Max</div>
            </div>
            <div className="text-item">
              <span className="common-left text-l">Cost</span>
              <span className="common-right text-r-1">{count} Gacha</span>
            </div>
            <div className="text-item">
              <span className="common-left text-l">Gas Fee</span>
              <span className="common-right text-r-2">0.001ETH</span>
            </div>
            <div className={`mint-btn ${isMinting || isApproving ? 'minting' : ''} ${count > gacha ? 'mint-disabled' : ''}`} onClick={handleClick} >{ btnText }</div>
            {count > gacha && (
              <NotEnghougGacha>
                <ReactSVG onClick={handleDecrement} className="gacha" src={GachaImg} beforeInjection={(svg) => { svg.setAttribute('style', 'display: flex')}}/>
                <span>not enough gacha, please check your wallet</span>
              </NotEnghougGacha>
            )}  
          </div>
          <div className="inner-right">
            <div className="f-l">
            {
              [1,1,1].map((i, idx) => <img className="nft-img" src={!idx ? NftImg6 : (idx === 1 ? NftImg5 : NftImg1 )} key={idx} alt="" />)
            }
            </div>
            <div className="s-l">
            {
              [1,1,1].map((i, idx) => <img className="nft-img" src={!idx ? NftImg2 : (idx === 1 ? NftImg3 : NftImg4 )} key={idx} alt="" />)
            }
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
const NotEnghougGacha = styled.div`
  display: flex;
  align-items: center;
  margin-top: 14px;
  color:#FF5E5E;
  span{
    margin-top: -2px;
  }
  .gacha{
    margin-right: 8px;
  }
`
const Modal = styled.div`

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .close {
    position: absolute;
    right: 44px;
    top: 40px;
    cursor: pointer;
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    padding: 30px 40px;
    .main-title{
      width: 100%;
      font-weight: 600;
      text-align: left;
      font-size: 30px;
      line-height: 42px;
      padding-bottom: 20px;
      color: #32DE86;
    }
    .line{
      width: 100%;
      height: 1px;
      background: rgba(255, 255, 255, 0.15);
    }
    .inner{
      display: flex;
      padding-top: 20px;
      .common-line{
        display: flex;
        align-items: center;
      }
      .common-left{
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        color: rgba(255, 255, 255, 0.6);
      }
      .common-right{
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #fff;        
      }
      .inner-right{
        .nft-img{
          width: 168px;
          border-radius: 20px;
          & + .nft-img{
            margin-left: 20px;            
          }
        }
        .f-l{
          display: flex;
        }
        .s-l{
          display: flex;
          padding-top: 20px;
        }
      }
      .inner-left {
          user-select: none;
        .title{
          font-weight: 600;
          font-size: 40px;
          line-height: 56px;
          color: #32DE86;
          padding-bottom: 22px;
        }
        .sub-title{
          .sub-title-l{
           
          }
          .sub-title-r{
            padding-left: 54px;
          }
        }
        .desc{          
          font-weight: 400;
          font-size: 20px;
          line-height: 28px;
          display: flex;
          margin-top: 20px;
          .ques-img{
            align-self: flex-start;
            margin-top: 6px;
            margin-right: 8px;
          }
          .desc-content{
            color: rgba(255, 255, 255, 0.3);
          }
        }
        .btn-comp{
          margin: 20px 0;
          display: flex;
          align-items: center;
          .button-control{
            color: #32DE86;
            display: flex;
            justify-content: space-between;
            background: #1A1A1A;
            border-radius: 8px;
            width: 229px;
            height: 44px;
            line-height: 44px;
            align-items: center;
            box-sizing: border-box;
            padding: 0 22px;
            font-size: 20px;
            .bc-l{
              cursor: pointer;
            }
            .bc-r{
              cursor: pointer;
            }

          }
          .max-txt{
            background: #1A1A1A;
            border-radius: 8px;
            text-align: center;
            width: 140px;
            height: 44px;
            line-height: 44px;
            color: #32DE86;
            margin-left: 20px;
            cursor: pointer;
          }

        }
        .text-item{
          & + .text-item{
            margin-top: 20px;
          }
          .text-l{
            

          }
          .text-r-1{
            padding-left: 130px;
          }
          .text-r-2{
            padding-left: 97px;            
          }
        }
        .mint-btn{
          width: 392px;
          height: 44px;
          line-height: 44px;
          background: #32DE86;
          border-radius: 8px;
          text-align: center;
          margin-top: 30px;
          cursor: pointer;
          &.mint-disabled{
            background: #999;
            color: rgba(255, 255, 255, 0.3);
            cursor: auto;
          }
          &.minting{
            background: rgba(50, 222, 134, 0.3);
          }
        }

      }
      .inner-right{

      }
    }
  }

  

`;
